export default "__VITE_ASSET__076ac0ac__"